import {
  AlertTriangle, Store, Heart, Newspaper, Calendar, Search, FileText, Scale, PartyPopper, Bus, Train, Bike,
  Trophy, Recycle, Phone, Fuel, BatteryCharging, Landmark, Car, HelpCircle,
} from 'lucide-react';

// What each kind of search result is called, drawn and coloured: the header search and the
// /buscar page say the same thing (backend/services/search.py sets `type`).
export const SEARCH_TYPE_ICONS = {
  incidencia: AlertTriangle, comercio: Store, farmacia: Heart, boletin: Newspaper, evento: Calendar, pagina: Search,
  tramite: FileText, contrato: Scale, patrona: PartyPopper, parada: Bus, linea: Bus, estacion: Train, bici: Bike,
  partido: Trophy, residuo: Recycle, servicio: Phone, gasolinera: Fuel, recarga: BatteryCharging,
  lugar: Landmark, trafico: Car, obra: AlertTriangle, faq: HelpCircle,
};
export const SEARCH_TYPE_LABELS = {
  incidencia: 'Incidencia', comercio: 'Comercio', farmacia: 'Farmacia', boletin: 'Boletín', evento: 'Evento', pagina: 'Página',
  tramite: 'Trámite', contrato: 'Contrato', patrona: 'La Patrona', parada: 'Parada', linea: 'Línea', estacion: 'Estación',
  bici: 'TorreBici', partido: 'Partido', residuo: 'Reciclaje', servicio: 'Teléfono',
  gasolinera: 'Gasolinera', recarga: 'Recarga', lugar: 'Lugar', trafico: 'Tráfico', obra: 'Obras', faq: 'Pregunta',
};
export const SEARCH_TYPE_COLORS = {
  incidencia: '#ef4444', comercio: '#eab308', farmacia: '#10B981', boletin: '#3b82f6', evento: '#8b5cf6', pagina: '#64748b',
  tramite: '#0F766E', contrato: '#1e293b', patrona: '#ef4444', parada: '#0891B2', linea: '#0891B2', estacion: '#7C3AED',
  bici: '#16A34A', partido: '#f59e0b', residuo: '#65A30D', servicio: '#EC4899',
  gasolinera: '#EA580C', recarga: '#0EA5E9', lugar: '#0D9488', trafico: '#DC2626', obra: '#D97706', faq: '#0D9488',
};

// Where a result goes: its own path; a pharmacy without one, the pharmacies page.
export function resultPath(item) {
  return item.path || (item.type === 'farmacia' ? '/farmacias' : '/');
}

// The server's results and the preguntas frecuentes found locally (lib/localSearch), as one
// list: local hits after the server's first eight, so a question never pushes a stop or a
// pharmacy off the top; a question that repeats a result's title is shown once.
export function mergeResults(remote, local, norm) {
  const seen = new Set(remote.map((r) => norm(r.title)));
  const extra = local.filter((r) => !seen.has(norm(r.title)));
  return [...remote.slice(0, 8), ...extra, ...remote.slice(8)];
}

// Results grouped by kind, groups in the order their best result ranked.
export function groupByType(results) {
  const groups = [];
  const byType = new Map();
  results.forEach((r) => {
    if (!byType.has(r.type)) {
      const g = { type: r.type, label: SEARCH_TYPE_LABELS[r.type] || 'Otros', items: [] };
      byType.set(r.type, g);
      groups.push(g);
    }
    byType.get(r.type).items.push(r);
  });
  return groups;
}
